import { computed, ref } from 'vue';
import { buildActivityFeed } from '@/lib/hubActivity.js';

/**
 * The Live from the trails block's feed: the hub's "Activity today"
 * (lib/hubActivity.js over site_data.activity), so a site and its hub
 * say the same thing about the same day. Shared by the Classic and
 * Trailhead renderers; Backyard draws with Trailhead's.
 *
 * Config: `max_items` rows before a Show more bar (0 = all), and
 * `show_weather` to leave the weather rows out for a site that already
 * carries a forecast block.
 */
export const LIVE_ACTIVITY_DEFAULT_MAX = 6;

export function useLiveActivity(props) {
    const feed = computed(() => {
        const a = props.site_data?.activity || {};
        const rows = buildActivityFeed({
            posts: a.posts,
            timeline: a.timeline,
            orgName: props.org?.name,
            units: a.units || 'metric',
        });
        return props.config.show_weather === false ? rows.filter((r) => r.tone !== 'weather') : rows;
    });

    const limit = computed(() => {
        const n = Number(props.config.max_items ?? LIVE_ACTIVITY_DEFAULT_MAX);
        return Number.isFinite(n) && n > 0 ? Math.floor(n) : Infinity;
    });
    const showAll = ref(false);
    const shown = computed(() => (showAll.value ? feed.value : feed.value.slice(0, limit.value)));
    const hiddenCount = computed(() => (showAll.value ? 0 : Math.max(0, feed.value.length - limit.value)));

    // Photos open in the hub's own lightbox.
    const lightboxImages = ref([]);
    const lightboxIndex = ref(null);
    const openPhoto = (post, i) => {
        lightboxImages.value = post.image_urls || [];
        lightboxIndex.value = i;
    };

    return { feed, shown, hiddenCount, showAll, lightboxImages, lightboxIndex, openPhoto };
}
